export default function LoadingSpinner({
  size = 'md',
  className = '',
  label = null,
}) {
  return (
    <div
      className={`vb-spinner-wrap${className ? ` ${className}` : ''}`}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <span
        className={`vb-spinner vb-spinner--${size}`}
        aria-hidden="true"
      />
      {label ? <span className="vb-spinner__label">{label}</span> : null}
    </div>
  );
}
